module.exports = __webpack_public_path__ + "img/u6_anziwuxue.45834843.jpg";